export const entries = (obj) => Object.entries(obj);
export const values = (obj) => Object.values(obj);
export const keys = (obj) => Object.keys(obj);
export function nonNullable(x) {
    return x !== undefined && x !== null;
}
